<template>
  <div class="content ht-100v pd-0">
    <div class="content-header">
      <div class="content-search">
        <feather type="search"></feather>
        <input type="search" class="form-control" placeholder="Search mail" />
      </div>
      <!-- <nav class="nav">
        <a class="nav-link">
          <feather type="help-circle"></feather>
        </a>
      </nav>-->
    </div>

    <div class="content-body pd-0">
      <div class="mail-wrapper mail-wrapper-two">
        <div class="mail-sidebar">
          <div class="mail-sidebar-body ps ps--active-y">
            <div class="pd-20">
              <button
                @click="handleLocalMailCompose({ isShow: true })"
                id="mailComposeBtn"
                class="btn btn-primary btn-block tx-uppercase tx-10 tx-medium tx-sans tx-spacing-4"
              >
                Шинэ
              </button>
            </div>
            <div class="pd-b-10 pd-x-10">
              <nav class="nav nav-sidebar tx-13">
                <a
                  v-for="f in folders"
                  :key="f.id"
                  @click="loadList(f)"
                  role="button"
                  :class="`nav-link ${f.id == folderCur ? 'active' : ''}`"
                >
                  <feather type="inbox" :size="14"></feather>
                  <span>{{ f.title }}</span>
                  <!-- <span class="badge">0</span> -->
                </a>
              </nav>
            </div>

            <!-- <div class="pd-y-15 pd-x-10">
              <label
                class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
              >Хайх</label>
            </div>-->
          </div>
        </div>

        <div class="mail-group">
          <div class="mail-group-header justify-content-between">
            <h6 class="tx-uppercase tx-semibold mg-b-0">
              {{ folderCurTitle }}
            </h6>
            <!-- <div class="dropdown tx-13">
              <span class="tx-color-03">Sort:</span>
              <a href class="dropdown-link link-02">Date</a>
            </div>-->
            <!-- dropdown -->
          </div>
          <vue-custom-scrollbar
            class="mail-group-body"
            :style="`height:${mailListHeight}px`"
            :settings="{ maxScrollbarLength: 60 }"
          >
            <div :key="i" v-for="(m, i) in mails">
              <label
                class="mail-group-label"
                v-show="isDrawGroupDateRange(i)"
                >{{ m.groupDate }}</label
              >
              <ul class="list-unstyled media-list mg-b-0">
                <li
                  @click="loadMail(m)"
                  class="media"
                  :class="{ unread: !m.isSeen && m.id != mailCur.id }"
                >
                  <div class="avatar">
                    <img :src="m.fromUser.avator" class="rounded-circle" />
                    <!-- <span class="avatar-initial rounded-circle bg-indigo">d</span> -->
                  </div>
                  <div class="media-body mg-l-15">
                    <div
                      class="tx-color-03 d-flex align-items-center justify-content-between mg-b-2"
                    >
                      <span class="tx-12">{{ m.fromUser.fullName }}</span>
                      <span class="tx-11">{{
                        m.sentDate | moment("HH:mm")
                      }}</span>
                    </div>
                    <h6
                      v-if="!m.isSeen && m.id != mailCur.id"
                      class="tx-13 loc-mail-subj"
                      :title="m.subject"
                    >
                      <span class="tx-11" v-if="m.hasAttach">
                        <!-- <i class="ivu-icon ivu-icon-md-attach" style="font-size:14px;"></i> -->
                        <feather size="14" type="paperclip"></feather>
                      </span>
                      {{ m.subject }}
                    </h6>
                    <div v-else class="tx-13">
                      <span class="tx-11" v-if="m.hasAttach">
                        <feather size="14" type="paperclip"></feather>
                      </span>
                      {{ m.subject }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="pd-t-1 pd-b-5 pd-x-5">
              <a
                @click="showMore()"
                class="btn btn-xs btn-block btn-light bd-0 tx-uppercase tx-10 tx-spacing-1 tx-medium mn-ht-0"
                >Цааш</a
              >
            </div>
          </vue-custom-scrollbar>
        </div>
        <!-- mail-group -->

        <div class="mail-content" v-if="mailCur.id > 0">
          <div class="mail-content-header" ref="mailContentHeader">
            <a
              id="mailContentClose"
              class="link-02 d-none d-lg-block d-xl-none mg-r-20"
            >
              <feather type="arrow-left"></feather>
            </a>
            <div class="media">
              <div class="avatar avatar-sm">
                <img
                  :src="mailCur.fromUser.avator"
                  class="rounded-circle"
                  alt
                />
              </div>
              <div class="media-body mg-l-10">
                <h6 class="mg-b-2 tx-13">{{ mailCur.fromUser.fullName }}</h6>
                <span class="d-block tx-11 tx-color-03">{{
                  mailCur.sentDate | moment("LLLL")
                }}</span>
              </div>
            </div>
            <nav class="nav nav-icon-only mg-l-auto">
              <a @click="showUsers(mailCur.id)" role="button" class="d-flex">
                <feather type="users" size="14" class="mg-r-5"></feather
                >Хэрэглэгчдийн жагсаалт
              </a>
              <!-- <a
                href
                data-toggle="tooltip"
                title
                class="nav-link d-none d-sm-block"
                data-original-title="Archive"
              >
                <feather type="archive"></feather>
              </a>-->
            </nav>
          </div>
          <div class="mail-content-body">
            <div class="pd-20 pd-lg-25 pd-xl-30">
              <h5 class="mg-b-30">{{ mailCur.subject }}</h5>
            </div>
            <vue-custom-scrollbar
              class="pd-20 pd-lg-25 pd-xl-30 pd-t-0-f bd-b"
              :style="`height:${mailBodyHeight}px`"
            >
              <div v-html="mailCur.body"></div>
              <div>
                <div class="divider-text">Хавсралт</div>
                <div class="row row-xs" v-if="mailCur.attachments.length > 0">
                  <div
                    :key="i"
                    class="col-sm-4 col-md-2"
                    role="button"
                    @click="showAttachment(a)"
                    v-for="(a, i) in mailCur.attachments"
                  >
                    <div class="card card-file">
                      <div class="card-file-thumb">
                        <img :src="getthumb(a)" class="wd-100p ht-100p" />
                      </div>
                      <div class="card-body">
                        <h6>
                          <a :title="a.nm" class="link-02">{{ a.nm }}</a>
                        </h6>
                        <div class="d-flex">
                          <span>{{
                            a.size > 1024
                              ? (a.size / 1024 / 1024).toFixed(2) + "MB"
                              : (a.size / 1024).toFixed(2) + "KB"
                          }}</span>
                          <span class="mg-l-auto"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-custom-scrollbar>
          </div>
          <!-- mail-content-body -->
        </div>
        <div v-else class="mail-content">
          <div
            class="text-center"
            style="position: absolute; top: 0; left: 0; z-index: 8; width: 100%; height: 100%;"
          >
            <div style="position: absolute; top: 40%; left: 40%;">
              <img src="assets/svg/emailopen.svg" style="width: 200px;" />
              <div class="text-muted">Жагсаалт хэсгээс дарж нээнэ үү</div>
            </div>
          </div>
        </div>
        <!-- mail-content -->
      </div>
    </div>

    <b-sidebar
      right
      shadow
      backdrop
      v-model="mailUsersObj.drawerShow"
      width="90%"
      @change="visibleChanged"
      prop
    >
      <virtual-list
        style="height: calc(100vh - 100px); overflow-y: auto;"
        :data-key="'id'"
        :data-sources="mailUsersObj.list"
        :data-component="ItemUser"
        :keeps="50"
        :estimate-size="21"
      />
    </b-sidebar>
    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      swd="85vw"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
const moment = require("moment");
import VirtualList from "vue-virtual-scroll-list";
import ItemUser from "./userVirtualTheme.vue";
import { request } from "@/api/all";
import { getObjectTitleById } from "@/libs/util";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { mapActions } from "vuex";

export default {
  components: {
    "virtual-list": VirtualList,
    vueCustomScrollbar,
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      ItemUser: ItemUser,
      filterParams: {
        name: ""
      },
      scrHeight: 0,
      mailBodyHeight: 200,

      searchModel: {
        page: 0,
        skip: 0,
        size: 20,
        folderId: 0,
        fromUserTaskId: [],
        labelIds: [],
        sentDateStart: null,
        sentDateEnd: null,
        subject: "",

        firstName: "",
        title: "",
        startDate: "",
        endDate: ""
      },

      loading: {
        folder: false,
        list: false,
        detail: false
      },

      folders: [],
      folderCur: 0,
      folderCurCode: "",
      folderCurTitle: "",
      mailsObj: {
        allCount: 0,
        count: 0
      },
      mails: [],
      mailCur: {
        id: 0,
        attachments: []
      },
      mailCurTab: 0,

      taskCur: {
        id: 0
      },
      taskCurKey: 0,
      taskCurRender: false,
      taskCurModal: false,

      mailUsersObj: {
        drawerRender: false,
        drawerShow: false,
        list: [],
        rawCount: 0,
        raw: [],
        btnActive: 1
      },

      fileDialog: {
        show: false,
        id: 0
      },
      updatedCount: 0,
      createShow: true,
      mailListHeight: 300
    };
  },

  mounted() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }

    //console.log(this.$route);
    this.toggleBodyClass("addClass", "app-mail");
    require("@/assets/scss/pages/mail.scss");
    require("@/assets/scss/pages/filemgr.scss");
    this.init();
    window.addEventListener("resize", this.getWindowHeight);
  },
  destroyed() {
    Object.assign(this.$data, this.$options.data());
    this.toggleBodyClass("removeClass", "app-mail");
    this.toggleBodyClass("removeClass", "dynamic-locker");
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    ...mapActions(["handleLocalMailCompose", "handleUserInfoModal"]),
    getWindowHeight() {
      this.mailListHeight = window.innerHeight - 122;
      this.$nextTick(function() {
        if (this.mailCur.id > 0) {
          this.mailBodyHeight =
            window.innerHeight -
            (172 + this.$refs.mailContentHeader.offsetHeight);
        }
      });
    },
    init() {
      this.loading.folder = true;
      request({
        api: { method: "GET", url: "LocalMail/Folders" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.folders = res.data.folders;
          let fia = res.data.folders.filter(x => x.code == "inbox");
          if (fia.length > 0) {
            this.loadList(fia[0]);
          }
          this.loading.folder = false;
          this.getWindowHeight();
        }
      });
    },
    loadList(f) {
      let self = this;
      this.loading.list = true;

      if (this.folderCurCode == "sent" || this.folderCurCode == "draft") {
        this.searchModel.firstName = "";
      }

      this.folderCur = f.id;
      this.folderCurCode = f.code;
      this.folderCurTitle = f.title;

      this.mails = [];

      this.searchModel.folderId = f.id;

      if (!f.paged) {
        this.searchModel.skip = 0;
        this.searchModel.page = 0;
      }

      request({
        api: { method: "POST", url: "LocalMail/List" },
        data: this.searchModel,
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.loading.list = false;
          this.mailCur.id = 0;
          //this.mails= res.data.list;

          this.mailsObj.allCount = res.data.allCount;
          this.mailsObj.count = res.data.count;

          this.mails = res.data.list.map(e =>
            Object.assign(e, {
              groupDate: self.getDateGroupName(e.sentDate)
            })
          );
        }
      });
    },
    showMore() {},
    loadMail(m) {
      request({
        api: { method: "get", url: "LocalMail/Detail" },
        params: { id: m.id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.mailCur = res.data.mail;

          if (this.mails.filter(x => x.id == res.data.mail.id).length > 0) {
            this.mails.filter(x => x.id == res.data.mail.id)[0].isSeen = true;
          }
          this.getWindowHeight();
        }
      });
    },
    // loadMailAfter() {

    // },
    getthumb(v) {
      let rv = "";
      if (this.mailCurTab == 0) {
        if (v.ext == "jpg" || v.ext == "jpeg" || v.ext == "png") {
          rv = v.link + "?w=220";
        } else {
          rv = this.myResBaseUrl + "media/mime/" + v.ext + ".png";
        }
      } else if (this.mailCurTab == 1) {
        rv = this.myResBaseUrl + "media/mime/" + "pdf" + ".png";
      } else if (this.mailCurTab == 2) {
        rv = v.avator;
      }
      return rv;
    },
    getObjectTitleById(ot) {
      return getObjectTitleById(this.$store.state.app.objectTypes, ot);
    },
    isDrawGroupDateRange(i) {
      if (i == 0) {
        return true;
      } else if (this.mails[i]["groupDate"] != this.mails[i - 1]["groupDate"]) {
        return true;
      } else {
        return false;
      }
    },
    getDateGroupName(d) {
      let rv = "";

      if (moment(d).isSame(new Date(), "day")) {
        rv = "Өнөөдөр";
      } else if (moment(d).isSame(moment().subtract(1, "day"), "day")) {
        rv = "Өчигдөр " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(moment().subtract(2, "day"), "day")) {
        rv = "Уржигдар " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(new Date(), "week")) {
        rv = "Энэ долоо хоногт";
      } else if (moment(d).isSame(moment().subtract(1, "week"), "week")) {
        rv = "Өнгөрсөн долоо хоногт";
      } else if (moment(d).isSame(new Date(), "month")) {
        rv = "Энэ сард";
      } else if (moment(d).isSame(moment().subtract(1, "month"), "month")) {
        rv = "Өнгөрсөн сард";
      } else if (moment(d).isSame(new Date(), "year")) {
        rv = moment(d).format("MMMM") + "д";
        //rv= 'Энэ жилд';
      } else if (moment(d).isSame(moment().subtract(1, "year"), "year")) {
        rv = "Өнгөрсөн жилд";
      } else {
        rv = moment(d).format("YYYY") + " онд";
        //rv='Бусад';
      }
      return rv;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    showTask(t) {
      this.taskCur = t;
      this.taskCurModal = true;
      this.taskCurRender = true;
      this.$nextTick(function() {
        this.taskCurKey++;
      });
    },
    attachmentDrawerClose() {
      //this.attachDrawerParams.fileId='';
      this.fileDialog.show = false;
    },
    showAttachmentDrawer(p) {
      //console.log(p);
      //this.attachDrawerParams.fileId=p.defaultAttachmentId;
      this.fileDialog.id = p.id;
      this.fileDialog.show = true;
    },
    showUsers(v) {
      request({
        api: { method: "post", url: "LocalMail/DetailUsers" },
        data: { id: v, page: 0, size: 2000 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.mailUsersObj.rawCount = res.data.count;
          this.mailUsersObj.raw = res.data.users;
          this.mailUsersObj.list = res.data.users;
          this.mailUsersObj.drawerRender = true;
          this.$nextTick(function() {
            this.mailUsersObj.drawerShow = true;
          });
        }
      });
    },
    showAttachment(a) {
      //console.log(a);
      //beforeLoadAttachment
      if (a.gId == this.$store.state.user.userInfo.groupId) {
        this.showAttachmentDrawer(a);
      } else {
        window.open(a.link, "_blank");
      }
    },
    visibleChanged(e) {
      if (!e) {
        this.mailUsersObj.list = [];
        this.mailUsersObj.drawerShow = false;
        //Object.assign(this.$data, this.$options.data());
        //this.$emit("on-task-close");
      }
    }
  }
};
</script>
